import React from 'react';
import classNames from 'classnames';

import {ErrorField} from 'components/Fields';
import keyIcon from './assets/key-icon.svg';

import './styles.css';

const PasswordField = ({
  input: {onChange, onBlur, value},
  placeholder,
  className,
  disabled,
  meta: {touched, error}
}: any) => {
  return (
    <div className="PasswordField">
      <div className="inputWrapper">
        <div className="icon">
          <img src={keyIcon} alt="Email icon" />
        </div>
        <input
          onChange={onChange}
          onBlur={onBlur}
          className={classNames({error: touched && error}, className)}
          placeholder={placeholder}
          type="password"
          value={value}
          disabled={disabled}
        />
      </div>
      <ErrorField touched={touched} error={error} />
    </div>
  );
};

export default PasswordField;
